import React from 'react';

const SeoBlock = () => {
  return (
    <section className="pt-4 pb-16 bg-[#070b14]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="sr-only">About PRBoost SEO Backlinks Service</h2>
        <p className="text-slate-500 text-sm leading-loose prose prose-invert mx-auto">
          PRBoost is a platform for businesses and agencies to secure high-quality placements, manage campaigns, and scale link building with full transparency.
        </p>
      </div>
    </section>
  );
};

export default SeoBlock;